import type {CSSProperties} from 'react';
import {radius, weight} from '../scale.js';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeContactEditorLook = 'contacts-editor-icon' | 'contacts-editor-toggle';

const EDITOR_LOOKS = new Set<string>(['contacts-editor-icon', 'contacts-editor-toggle']);
export const isWedgeContactEditorLook = (look: string): look is WedgeContactEditorLook => EDITOR_LOOKS.has(look);

/* Released raw buttons of the rep contact editor in the account card (prep-account-contacts RvContactEditor), off-scale. The icon look is
   the pencil, close and dismiss button: a clear 44px box (the tap button box with no padding and a fixed width) in the secondary ink on
   no fill. The toggle look is the full width "Your contacts" row: a flex row on no fill and no border in the inherited ink, the caller
   sets the row padding from the card density table. Both boxes are 44px already, so no look here draws a transparent target
   (wedgeContactEditorDrawsHit), and the contacts- prefix rule of the rep contact form already covers them. */
export const wedgeContactEditorDrawsHit = (look: string): boolean => !isWedgeContactEditorLook(look);

export function wedgeContactEditorStyle(look: WedgeContactEditorLook): CSSProperties {
  const r = wedgeExactRole;
  if (look === 'contacts-editor-toggle') {
    return {
      display: 'flex', alignItems: 'center', gap: 12, minHeight: 44, width: '100%', textAlign: 'left',
      background: 'none', border: 'none', color: 'inherit', fontFamily: r('font'), cursor: 'pointer',
    };
  }
  return {
    minHeight: 44, minWidth: 44, padding: 0, width: 44, borderRadius: radius.md, border: 'none', cursor: 'pointer',
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, fontFamily: r('font'), fontSize: 14, fontWeight: weight.bold,
    background: 'transparent', color: r('labelSec'),
  };
}
